//import moment from 'moment'
import moment from 'moment-timezone'
import jstz from 'jstimezonedetect'

export const formatTaskDate = date => (
	moment(date).format('Y-MM-DD')
)

export const formatFileDate = date => (
	formatByTimeZone(date, 'Y-MM-DD h:mm a', true).fromNow()
)

export const formatDeadlineDate = date => {
	if (typeof date == 'string') {
		return moment(date).format('MMM D')
	} else {
		return date.format('MMM D')
	}
}

export const formatStandardDateTime = (object, key = null, dateOnly, separator = ' •', isMoment = false) => {
	const objectMoment = isMoment ? object : moment(object[key])

	if (dateOnly) {
		return objectMoment.format('MMMM Do')
	} else {
		return objectMoment.format('h:mm a') + separator + ' ' + objectMoment.format('MMMM Do')
	}
}

export const formatByTimeZone = (date = null, format = null, returnMoment = false) => {
	let returnValue
	const dateFormat = format ? format : 'h:mm a'

	const userTimezone = moment.tz.guess()

	moment.tz.setDefault('Australia/Melbourne')

	returnValue = date ? moment(date).tz(userTimezone) : moment().tz(userTimezone)

	if (!returnMoment) {
		returnValue = returnValue.format(dateFormat)
	}

	moment.tz.setDefault()

	return returnValue
}

export const isWeekDay = dateMoment => {
	const dayIndex = dateMoment.toDate().getDay()

	return dayIndex != 6 && dayIndex != 0
}

export const secondsToTimeString = (input, showSeconds = true) => {
	let hours = Math.floor(moment.duration(input, 'seconds').asHours()).toString()
	let minutes = moment.duration(input, 'seconds').minutes().toString()
	let seconds = moment.duration(input, 'seconds').seconds().toString()

	if (hours.length == 1) {
		hours = '0' + hours
	}

	if (minutes.length == 1) {
		minutes = '0' + minutes
	}

	if (seconds.length == 1) {
		seconds = '0' + seconds
	}

	let formattedDuration = hours + ':' + minutes

	if (showSeconds) {
		formattedDuration += ':' + seconds
	}

	return formattedDuration
}

export const minutesToTimeString = input => {
	let hours = Math.floor(moment.duration(input, 'minutes').asHours()).toString()
	let minutes = moment.duration(input, 'minutes').minutes().toString()

	if (hours.length == 1) {
		hours = '0' + hours
	}

	if (minutes.length == 1) {
		minutes = '0' + minutes
	}

	const formattedDuration = hours + ':' + minutes

	return formattedDuration
}

export const timeStringFromSession = session => {
	const secondsCount = getSessionSeconds(session, true)

	return secondsToTimeString(secondsCount)
}

export const getSessionSeconds = (session, includeRunning) => {
	const stoppedSession = session.stopped_at ? formatByTimeZone(session.stopped_at, null, true) : includeRunning ? moment() : null

	const secondsCount = stoppedSession ? stoppedSession.diff(formatByTimeZone(session.created_at, null, true), 'seconds') : 0

	return secondsCount
}

export const textTimeString = (value, type, isLong) => {
	let response = ''
	let hours = 0
	let minutes = 0

	switch (type) {
		case 'seconds':
			hours = Math.floor(moment.duration(value, 'seconds').asHours()).toString()
			minutes = moment.duration(value, 'seconds').minutes().toString()

			break
		case 'minutes':
			hours = Math.floor(moment.duration(value, 'minutes').asHours()).toString()
			minutes = moment.duration(value, 'minutes').minutes().toString()

			break
	}

	if (!hours && !minutes) {
		return ''
	}

	if (hours != 0) {
		response = hours

		if (!isLong) {
			response += 'h '
		} else {
			response += 'hr '
		}
	}

	response += minutes

	if (!isLong) {
		response += 'm'
	} else {
		response += 'min'
	}

	return response
}

export const momentToApiTimeFormat = (passedMoment = moment()) => {
	return passedMoment.format("YYYY-MM-DD HH:mm:ss")
}


// WEBPACK FOOTER //
// ./src/utils/time.js